module.exports = __webpack_public_path__ + "static/media/charity-icon.fe5e6ede.svg";